/**
 * report模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const report = {
  //自动化运维报告添加
  createReport(params) {
    return $http.post(`${global.API_URL}/sme/report/create`,params);
  },
  //自动化运维报告删除
  deleteReport(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/report/delete`,param);
  },
  //自动化运维报告分页
  pageReport(params) {
    return $http.post(`${global.API_URL}/sme/report/page`,params);
  },
  //自动化运维报告更新
  updateReport(params) {
    return $http.post(`${global.API_URL}/sme/report/update`,params);
  },
  //更新财务分析
  updateBillAnalysis(params) {
    return $http.post(`${global.API_URL}/sme/report/updateBillAnalysis`,params);
  },
  //更新实例优化建议
  updateInstanceOptimizeSuggestion(params) {
    return $http.post(`${global.API_URL}/sme/report/updateInstanceOptimizeSuggestion`,params);
  },
  //更新数据库优化建议
  updateDatabaseOptimizeSuggestion(params) {
    return $http.post(`${global.API_URL}/sme/report/updateDatabaseOptimizeSuggestion`,params);
  },
  //根据ID查询Report
  queryById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/report/queryById`,param);
  }
}

export default report;



// WEBPACK FOOTER //
// ./src/api/report.js